import React, { ReactNode } from 'react';

import { useUserGridSettings } from './use-user-grid-settings';
import { UserGridSettingsContext } from './user-grid-settings-context';
import { userGridSettingsPersistor } from './user-grid-settings-persistor';
import { useBulkUpdateInvoicesBills } from './bulk-update-invoices-bills/use-bulk-update-invoices-bills';

export const UserGridSettingsProvider = (props: { children: ReactNode }) => {
  const storageValues = userGridSettingsPersistor.instance;
  const userGridSettings = useUserGridSettings(storageValues);
  const bulkUpdatesInvoicesBills = useBulkUpdateInvoicesBills();

  const contextValue = React.useMemo(() => ({ ...userGridSettings, bulkUpdatesInvoicesBills }), [
    userGridSettings,
    bulkUpdatesInvoicesBills
  ]);

  return <UserGridSettingsContext.Provider value={contextValue}>{props.children}</UserGridSettingsContext.Provider>;
};
